module.exports = {"pagination":{"ListTerminologies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTextTranslationJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/translate-2017-07-01.paginators.json
// module id = 1372
// module chunks = 0